import { render } from "./Canales.vue?vue&type=template&id=73a2d7b2&scoped=true"
import script from "./Canales.vue?vue&type=script&lang=js"
export * from "./Canales.vue?vue&type=script&lang=js"

import "./Canales.vue?vue&type=style&index=0&id=73a2d7b2&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a2d7b2"]])

export default __exports__